export default "__VITE_ASSET__31cd0ebc__"